import * as React from "react";

import {
  Box,
  Checkbox,
  FormControlLabel,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";

import { useMerchantModel, useTranslation } from "client/hooks";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

const useStyles = makeStyles((theme: Theme) => {
  const { blue } = useNormalizedBrandPaletteValues(theme);

  return {
    checkbox: {
      paddingTop: 0,
    },
    checked: {
      color: `${blue} !important`,
    },
    checkboxWrapper: {
      alignItems: "flex-start",
      fontSize: `${10 / 16}rem`,
    },
    spacer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
  };
});

interface BusinessAddressConfirmation {
  isBusinessAddressConfirmed: boolean;
  onChange: (e: any, checked: boolean) => void;
}

export const BusinessAddressConfirmationForm: React.FC<BusinessAddressConfirmation> = ({
  isBusinessAddressConfirmed,
  onChange,
}) => {
  const classes = useStyles();
  const { merchant } = useMerchantModel();
  const t = useTranslation();

  const country = merchant.companyInformation.registeredCountry.value;

  if (country === "New Zealand") {
    return (
      <Box className={classes.spacer}>
        <FormControlLabel
          className={classes.checkboxWrapper}
          control={
            <Checkbox
              checked={isBusinessAddressConfirmed}
              classes={{
                root: classes.checkbox,
                checked: classes.checked,
              }}
              onChange={onChange}
            />
          }
          label={
            <Typography variant="caption">
              {t("businessAddress_ConfirmationText")}
            </Typography>
          }
        />
      </Box>
    );
  }
  return null;
};
